export default __webpack_public_path__ + "build/static/media/prom-app-icon.9dd60e1e.svg";